var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max-w-lg m-auto"},[_vm._v("\n  You have been logged out\n")])}
var staticRenderFns = []

export { render, staticRenderFns }